
import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { queryClient } from './lib/queryClient';
import Index from "./pages/Index";
import HR from "./pages/HR";
import Administration from "./pages/Administration";
import Marketing from "./pages/Marketing";
import Sales from "./pages/Sales";
import Legal from "./pages/Legal";
import Finance from "./pages/Finance";
import Projects from "./pages/Projects";
import Performance from "./pages/Performance";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Index />,
  },
  {
    path: "/projectsdemo",
    element: <Index autoOpenProjectsDemo />,
  },
  {
    path: "/dashboard",
    element: <HR />,
  },
  {
    path: "/administration",
    element: <Administration />,
  },
  {
    path: "/marketing",
    element: <Marketing />,
  },
  {
    path: "/sales",
    element: <Sales />,
  },
  {
    path: "/legal",
    element: <Legal />,
  },
  {
    path: "/finance",
    element: <Finance />,
  },
  {
    path: "/projects",
    element: <Projects />,
  },
  {
    path: "/performance",
    element: <Performance />,
  },
]);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
